var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#29283C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4992 39.6604C59.4992 45.4855 54.8287 50.1563 48.9994 50.1563C43.1722 50.1563 38.4997 45.4855 38.4997 39.6604C38.4997 33.8353 43.1722 29.1665 48.9994 29.1665C54.8287 29.1665 59.4992 33.8353 59.4992 39.6604ZM48.9995 68.833C40.3965 68.833 33.1328 67.4348 33.1328 62.04C33.1328 56.6433 40.4422 55.2947 48.9995 55.2947C57.6044 55.2947 64.8661 56.6929 64.8661 62.0876C64.8661 67.4843 57.5568 68.833 48.9995 68.833Z",
    fill: "#363548"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.9fb168fbe2fffe080fb91ba32e98b28b.svg";
export { ForwardRef as ReactComponent };